import { render, staticRenderFns } from "./TransmissionSelect.vue?vue&type=template&id=d97d7e0a&"
import script from "./TransmissionSelect.vue?vue&type=script&lang=js&"
export * from "./TransmissionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports